var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFatArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.191,
    height: 76.458,
    viewBox: "0 0 70.191 76.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70.191 38.229 31.962 0 31.962 17.426 0 17.426 0 59.032 31.962 59.032 31.962 76.458 70.191 38.229",
    fill: "#1a1a1a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatArrow);
export default __webpack_public_path__ + "static/media/fat-arrow.52fa5646b63531f11d93f3c4cc6ba4cc.svg";
export { ForwardRef as ReactComponent };